import { useTranslation } from 'react-i18next'

import { LockSimpleIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const DisabledTriggerLabel = ({ label }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <Styles.Container>
      <LockSimpleIcon size={16} weight="light" color={theme.colors.text.subtle} />
      <Text tag="span" type="bodyMRegular" color={theme.colors.text.subtle}>
        {label}
      </Text>
      <Text tag="span" type="bodyMRegular" color={theme.colors.text.muted}>
        {`- ${t('Solo disponible con Smart Tracking')}`}
      </Text>
    </Styles.Container>
  )
}

export default DisabledTriggerLabel
